/*
 * WawiKundenAppQueries.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-11-02 in huWaWi3 33.4.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import gql from 'graphql-tag'

import {
  AUFTRAGSPOSITION_FRAGMENT,
  AUFTRAG_FRAGMENT,
  RESERVIERUNGSPOSITION_FRAGMENT,
  RESERVIERUNG_FRAGMENT,
} from '../fragments'

export const KUNDE_AUFTRAG_OFFEN_LIST_QUERY = gql`
  query KundenAuftraege($nr: ID!) {
    entity: hwKunde(designator: $nr) {
      nodes: auftraege(filter: { erledigt: { eq: false } }) {
        ...auftragFragment
      }
    }
  }
  ${AUFTRAG_FRAGMENT}
`
export const KUNDE_AUFTRAG_ERLEDIGT_LIST_QUERY = gql`
  query KundenAuftraege($nr: ID!) {
    entity: hwKunde(designator: $nr) {
      nodes: auftraege(filter: { erledigt: { eq: true } }) {
        ...auftragFragment
      }
    }
  }
  ${AUFTRAG_FRAGMENT}
`;

export const AUFTRAGPOS_LIST_QUERY = gql`
  query KundenAuftragsPos($nr: ID!) {
    entity: hwKunde(designator: $nr) {
      nodes: auftragsPositionen(filter: { erledigt: { eq: false } }) {
        ...auftragspositionFragment
      }
    }
  }
  ${AUFTRAGSPOSITION_FRAGMENT}
`

export const AUFTRAGPOS_ERLEDIGT_LIST_QUERY = gql`
  query KundenAuftragsPosErledigt($cursor: String, $kundennr: String!) {
    nodes: hwAuftragsPositionPages(
      after: $cursor
      filter: { empfaengernr: { eq: $kundennr } }
      sort: { fields: [anlieferdatum_bis], order: [DESC] }
    ) {
      edges {
        cursor
        node {
          ...auftragspositionFragment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${AUFTRAGSPOSITION_FRAGMENT}
`;


export const RESERVIERUNG_LIST_QUERY = gql`
  query KundenReservierungen($nr: ID!) {
    entity: hwKunde(designator: $nr) {
      nodes: reservierungen(filter: { erledigt: { eq: false } }) {
        ...reservierungFragment
      }
    }
  }
  ${RESERVIERUNG_FRAGMENT}
`
export const RESERVIERUNGSPOSITIONEN_LIST_QUERY = gql`
  query KundenReservierungspositionen($nr: ID!) {
    entity: hwKunde(designator: $nr) {
      nodes: reservierungsPositionen(filter: { erledigt: { eq: false } }) {
        ...resevierungspositionFragment
        item {
          id
          name
          produkt {
            id
            designator
            kategorie
            einheit
          }
          zukunft {
            id
            freie_menge
            frei_ab
            buchbestand
            zukuenftiger_zulauf
            naechster_zulauf
            zukuenftiger_ablauf
            naechster_ablauf
          }
          preisResolved {
            uvp
            fh
            id
            designator
            basis_name
            bartnr
          }
        }
      }
    }
  }
  ${RESERVIERUNGSPOSITION_FRAGMENT}
`

export const BELEG_LIST_QUERY = gql`
  query KundenBelege($nr: ID!) {
    entity: hwKunde(designator: $nr) {
      nodes: belege {
        # edges {
        #   cursor
        #   node {
        designator
        belegart
        belegdatum
        name
        kundennr
        empfaenger
        faktura {
          warenwert
          brutto_betrag
        }
        #   }
        # }
        # pageInfo {
        #   hasNextPage
        #   endCursor
        # }
      }
    }
  }
`
